import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { FeatureService } from '@app/_components/property/feature/feature.service';
import { PropertyService } from '@app/_components/property/property.service';
import { FeaturesService } from '@app/_components/feature/features.service';
import { FeatureAdminContainerComponent } from '../../feature/feature-admin-container/feature-admin-container.component';
import { PropertyFeatureTemplateService } from '../../property-feature-template/property-feature-template.service';
import { PropertyFeatureTemplateComponent } from '../../property-feature-template/property-feature-template/property-feature-template.component';

@Component({
    selector: 'app-property-feature-template-detail',
    templateUrl: './property-feature-template-detail.component.html',
    styleUrls: ['./property-feature-template-detail.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyFeatureTemplateDetailComponent implements OnInit {
    properties: any;
    features: any;
	propertyFeatures: any;
    propertyFeatureTemplates: any;

	constructor(
		private propertyFeatureTemplateService: PropertyFeatureTemplateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.formTitle = data.title,
			this.propertyFeatures = data.propertyFeatures? data.propertyFeatures : null;
	}


	// data
	propertyFeatureId: number;
	@Output() doAdd = new EventEmitter<any>();

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'propertyFeatureTemplateId': [],
	};

	ngOnInit() {
		this.fetchPropertyFeatureTemplate();
		this.formBuild();
	}

	
	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyFeatureTemplateId: []
		});
	}

	fetchPropertyFeatureTemplate() {
		if (!this.propertyFeatureTemplates || this.propertyFeatureTemplates === undefined || this.propertyFeatureTemplates.length < 1) {
			try {
				this.propertyFeatureTemplateService.findAll()
					.subscribe(
						res => {
							console.log('findAllpropertyFeatureTemplateSummary: ' + JSON.stringify(res));
							this.propertyFeatureTemplates = res.data.propertyFeatureTemplates;
							return this.propertyFeatureTemplates;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.propertyFeatureTemplates);
		}
	}

	addToTemplate() {
		try {
			console.log("this.propertyFeatures.length : "+this.propertyFeatures.length);
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
				for (let i = 0; i < this.propertyFeatures.length; i++) {
				this.propertyFeatures[i].propertyFeatureTemplateId = this.form1.value.propertyFeatureTemplateId;
			  	console.log("propertyFeature propertyFeature : "+JSON.stringify(this.propertyFeatures[i]));
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyFeatureTemplateService.addToTemplate(this.propertyFeatures)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Successfully add features', detail: res.message });
					},
					(err: any) => {
						console.log('propertyFeature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}
	
}
